import { render, staticRenderFns } from "./StaffCard.vue?vue&type=template&id=7632d581&scoped=true&"
import script from "./StaffCard.vue?vue&type=script&lang=js&"
export * from "./StaffCard.vue?vue&type=script&lang=js&"
import style0 from "./StaffCard.vue?vue&type=style&index=0&id=7632d581&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7632d581",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7632d581')) {
      api.createRecord('7632d581', component.options)
    } else {
      api.reload('7632d581', component.options)
    }
    module.hot.accept("./StaffCard.vue?vue&type=template&id=7632d581&scoped=true&", function () {
      api.rerender('7632d581', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/staffs/StaffCard.vue"
export default component.exports